// Vaikutuskartta v2 (apps/display/src/impactmap): the `impactMapV2` namespace,
// in its own file so the module's strings grow here, not in fi.js / en.js / sv.js
// (#1420). Effect-type keys match packages/shared/effectTypes.js; loop
// directions match impactmap/components/loopVisuals.js.

export const impactMapV2Fi = {
  effectTypes: {
    leads_to: 'johtaa',
    enables: 'mahdollistaa',
    blocks: 'estää',
    reinforces: 'vahvistaa',
    weakens: 'heikentää',
    nullifies: 'kumoaa',
    requires: 'edellyttää',
    delays: 'viivästyttää',
    relates_to: 'liittyy',
    is_same: 'sama asia',
  },
  view: {
    tabMap: 'Kartta',
    tabReadings: 'Lukemat',
    noInstanceTitle: 'Ei instanssia',
    noInstanceBody: 'Avaa kartta instanssin kanssa:',
    pickScenarioTitle: 'Valitse skenaario',
    pickScenarioIndividual: 'Omat-näkymä näyttää yhden skenaarion polkusi.',
    pickScenarioScenario: 'Skenaario-näkymä näyttää yhden skenaarion kaikki polut.',
    pickScenarioHint: 'Valitse skenaario tai katso koko kartta Kaikki-näkymässä.',
    allView: 'Kaikki →',
    loading: 'Ladataan karttaa…',
    emptyTitle: 'Kartta on tyhjä',
    emptyBody: 'Tässä näkymässä ei ole vielä solmuja. Lisää ensimmäinen seuraus vaikutuspolussa tai vaihda näkymää.',
    backToMap: '← Takaisin karttaan',
    blockerBadge: 'Este',
    loopTitleBalancing: 'Tasapainottava silmukka',
    loopTitleReinforcing: 'Vahvistava silmukka',
  },
  errors: {
    blockerAdd: 'Esteen lisäys epäonnistui (HTTP {{status}}).',
    commentSave: 'Huomion tallennus epäonnistui.',
    voteOwn: 'Omaa seurausta ei voi äänestää.',
    vote: 'Äänestys epäonnistui.',
    linkExists: 'Näiden välillä on jo yhteys.',
    linkCreate: 'Yhteyden luonti epäonnistui (HTTP {{status}}).',
    loopNotClosed: 'Tämä ei sulje silmukkaa — ketju ei palaa tähän solmuun, joten yhteyttä ei tallennettu. Piirrä uudelleen ja valitse "Yhteys", jos tarkoitit tavallista yhteyttä.',
    loopSave: 'Silmukan tallennus epäonnistui (HTTP {{status}}).',
    linkRetype: 'Yhteyden tyypin vaihto epäonnistui (HTTP {{status}}).',
    loopDirection: 'Silmukan suunnan tallennus epäonnistui (HTTP {{status}}).',
    suggestHttp: 'Ehdotusten haku epäonnistui (HTTP {{status}}).',
    suggest: 'Ehdotusten haku epäonnistui.',
    suggestWithMessage: 'Ehdotusten haku epäonnistui: {{message}}',
    aiUnavailable: 'AI ei ole käytettävissä (API-avain puuttuu).',
    edgeTypes: 'Kytkentöjen tyypitys epäonnistui (HTTP {{status}}).',
  },
  drawer: {
    onMap: 'Kartalla',
    consequences: 'Seuraukset',
    blockers: 'Esteet',
    crossLinks: 'Ristiinyhteydet',
    loops: 'Silmukat',
    loopsHint: 'Piirtää silmukat ja kahvan, josta yhteyden voi vetää solmusta toiseen',
    factCheck: 'AI-faktantarkistus',
    factCheckHint: 'Tarkistaa uudet solmut tietopohjaa vasten',
    edgeTypesHint: "Kytkentätyypin voi valita seurausta lisätessä; muut näkyvät oletuksena 'johtaa'.",
    edgeTypesCount: 'Kytkentätyypit: {{typed}}/{{total}} ihmisen valitsemaa',
    edgeTypesAi: ', {{count}} AI:n',
    typeEdges: 'Tyypitä kytkennät',
    typeEdgesHint: 'AI lukee jokaisen tyypittämättömän kytkennän ketjussaan ja ehdottaa tyypin. Ihmisen valinta säilyy.',
    typing: 'Tyypitetään…',
    findLoops: 'Ehdota silmukoita',
    findCross: 'Ehdota ristiinyhteyksiä',
    searching: 'Etsitään…',
    pendingLoops: 'silmukkaa tarkistamatta',
    pendingCross: 'yhteyttä tarkistamatta',
    queueHint: 'Ehdotukset menevät jonoon; karttaan vasta kun joku hyväksyy.',
    pulseAt: 'Pulssi {{time}}',
    pulseCandidates: '💓 Vipupiste-ehdokkaita {{count}}',
    pulseNew: ', {{count}} uutta',
    pivots: 'Vipupisteet',
    askTitle: 'Kysy kartalta',
    askChoices: 'Missä valinnat ovat?',
    askLoops: 'Mihin systeemi taipuu?',
    askBlockers: 'Mikä tukkii?',
    askHint: 'Yksi lukutapa kerrallaan. Kartta himmentää kaiken, mikä ei vastaa kysymykseen.',
    analysis: 'Analyysi',
  },
  readings: {
    loadFailed: 'Lukemien haku epäonnistui: {{message}}',
    retry: 'Yritä uudestaan',
    reading: 'Luetaan karttaa…',
    none: 'Ei lukemia.',
    totals: {
      consequences: 'seurausta',
      up: 'peukkua ylös',
      voted: 'solmua äänestetty',
      upPerNode: 'ylös / solmu',
      leaves: 'lehtiä',
      grounded: 'lähteistettyä',
    },
    heat: {
      title: 'Haarojen kuumuus',
      hint: 'Peukkuja solmua kohti muuttujan alla. Kartan keskiarvo {{mean}}. Pieni kuuma haara on se, mihin huone palaa.',
      rowTitle: '{{nodes}} solmua · {{writers}} kirjoittajaa · {{grounded}} lähteistettyä · syvyys {{depth}}',
      rowSub: '{{scenario}} · {{nodes}} solmua · {{writers}} kirj.',
      perNode: '/ solmu',
    },
    chains: {
      title: 'Kuumimmat ketjut',
      hint: 'Peukut summattuna juuresta lehteen. Tarina, johon huone uskoo eniten; leikkaa ryhmien ja haarojen poikki.',
      steps: '{{scenario}} · {{depth}} askelta',
      none: 'Ei vielä ketjuja.',
    },
    polarity: {
      title: 'Nuolien napaisuus',
      hint: '{{share}} % nuolista on heikentäviä tai estäviä. Ilman niitä kartalla ei voi olla tasapainottavia kierteitä.',
    },
    authorship: {
      title: 'Kuka kirjoitti minne',
      hint: 'Keskimäärin {{mean}} kirjoittajaa haaraa kohti, {{writers}} kirjoittajaa kartalla.',
      monologues: 'Yhden kirjoittajan haarat (monologi, ei keskustelu):',
      nodes: '{{count}} solmua',
      none: 'Jokaisella isommalla haaralla on useampi kirjoittaja.',
    },
    surprises: {
      title: 'Yllätykset syvällä',
      hint: 'Paljon peukkuja syvällä solmulla, vanhemmalla vähän: löytö hiljaisesta polusta.',
      sub: 'syvyys {{depth}} · alla: {{parent}} (+{{up}})',
      none: 'Ei yllätyksiä vielä.',
    },
    contested: {
      title: 'Kiistanalaiset',
      hint: 'Peukkuja ylös ja alas molempia paljon: huone on eri mieltä siitä, onko tällä väliä. Seinäkeskustelun paikka.',
      none: 'Ei kiistanalaisia solmuja.',
    },
    hotLeaves: {
      title: 'Kuumat lehdet',
      hint: 'Lehti, jolla on paljon peukkuja: tähän huone lopetti ajattelun. Seuraavan kierroksen ”mitä tästä seuraa”.',
      sub: '{{scenario}} · syvyys {{depth}}',
    },
    multiParent: {
      title: 'Kaksi vanhempaa',
      hint: 'Solmu, joka seuraa kahdesta paikasta: huoneen vahvin yhteneväisyys.',
      parents: '{{count}} vanhempaa',
      none: 'Ei vielä.',
    },
    written: 'Kartta kirjoitettiin {{from}} – {{to}}, {{nodes}} solmua.',
    rereading: 'Luetaan…',
    reread: 'Lue uudestaan',
  },
  analysis: {
    title: 'Analysoi kartta',
    labelPlaceholder: 'Nimi tälle ajolle (valinnainen)',
    running: 'Analysoidaan…',
    run: 'Analysoi',
    runningHint: 'Lukee koko kartan — noin minuutti.',
    untitled: 'Nimetön ajo',
    promptVersion: 'promptti v{{version}}',
    tendency: 'Mihin systeemi taipuu',
    keyChoices: 'Ratkaisevat valinnat',
    loops: 'Silmukat',
    blockers: 'Esteet',
    attention: 'Huomio seuraavaksi',
    earlier: 'Aiemmat ajot',
    listMeta: '{{nodes}} solmua, {{choices}} valintaa',
    refLoop: 'silmukka: {{title}}',
    refBlocker: 'este: {{text}}',
    countConsequences: '{{count}} seurausta',
    countVariables: '{{count}} muuttujaa',
    countItems: '{{count}} kohtaa',
    loadFailed: 'Analyysien haku epäonnistui: {{message}}',
    failed: 'Analyysi epäonnistui: {{message}}',
  },
  link: {
    connection: 'Yhteys',
    connectionSub: 'Tämäkin johtaa tuohon — solmulla on useampi syy.',
    loop: 'Silmukka',
    loopSub: 'Ketju palaa takaisin itseensä — vahvistava tai tasapainottava kierre.',
    same: 'On sama',
    sameSub: 'Sama asia sanottu kahdesti eri haaroissa — ei vaikutusta vaan päällekkäisyys.',
  },
  loop: {
    tone: { up: 'Hyvä kierre', down: 'Noidankehä', unknown: 'Silmukka — suunta arvioimatta' },
    word: { up: 'hyvä kierre', down: 'noidankehä', none: 'silmukka' },
    hint: { up: 'Kierre parantaa tilannetta joka kierroksella.', down: 'Kierre pahentaa tilannetta joka kierroksella.' },
    pick: {
      up: { label: 'Hyvä kierre', sub: 'Paranee joka kierroksella.' },
      down: { label: 'Noidankehä', sub: 'Pahenee joka kierroksella.' },
      unknown: { label: 'En tiedä vielä', sub: 'Jätä arvioimatta — voit päättää myöhemmin.' },
    },
  },
  suggestions: {
    loopsTitle: 'Ehdotetut silmukat',
    crossTitle: 'Ehdotetut ristiinyhteydet',
    noLoops: 'AI ei löytänyt ketjuja, jotka palaisivat itseensä. Se ei tarkoita ettei niitä ole — piirrä silmukka käsin, jos näet sellaisen.',
    noCross: 'AI ei löytänyt haarojen välisiä yhteyksiä, joita kartalla ei jo ole.',
    retype: 'Vaihda suhteen tyyppi',
    accept: 'Lisää kartalle',
    dismiss: 'Hylkää',
  },
  effectPicker: {
    question: 'Miten tämä seuraa edellisestä?',
    relation: 'Suhde:',
    change: 'muuta',
    more: 'muu',
  },
  scenarioPicker: {
    change: 'Vaihda skenaariota',
    pick: 'Valitse skenaario',
    listLabel: 'Skenaario',
  },
  node: {
    scenario: 'Skenaario',
    variable: 'Muuttuja',
    consequence: 'Seuraus',
    seamRoot: 'Yhdistetty juuri: {{count}} skenaariota. Napauta: näytä perhe.',
    seamPath: 'Polku jatkuu saumassa: sama asia {{count}} skenaariossa. Napauta: näytä perhe.',
    aiSuggests: 'Tekoäly ehdottaa yhteyttä tästä solmusta — tarkistamatta',
  },
};

export const impactMapV2En = {
  effectTypes: {
    leads_to: 'leads to',
    enables: 'enables',
    blocks: 'blocks',
    reinforces: 'reinforces',
    weakens: 'weakens',
    nullifies: 'cancels out',
    requires: 'requires',
    delays: 'delays',
    relates_to: 'relates to',
    is_same: 'same thing',
  },
  view: {
    tabMap: 'Map',
    tabReadings: 'Readings',
    noInstanceTitle: 'No instance',
    noInstanceBody: 'Open the map with an instance:',
    pickScenarioTitle: 'Choose a scenario',
    pickScenarioIndividual: 'The Mine view shows your paths in one scenario.',
    pickScenarioScenario: 'The Scenario view shows all paths in one scenario.',
    pickScenarioHint: 'Choose a scenario, or see the whole map in the All view.',
    allView: 'All →',
    loading: 'Loading the map…',
    emptyTitle: 'The map is empty',
    emptyBody: 'There are no nodes in this view yet. Add the first consequence in the impact path, or switch views.',
    backToMap: '← Back to the map',
    blockerBadge: 'Blocker',
    loopTitleBalancing: 'Balancing loop',
    loopTitleReinforcing: 'Reinforcing loop',
  },
  errors: {
    blockerAdd: 'Adding the blocker failed (HTTP {{status}}).',
    commentSave: 'Saving the note failed.',
    voteOwn: 'You cannot vote on your own consequence.',
    vote: 'Voting failed.',
    linkExists: 'These are already connected.',
    linkCreate: 'Creating the connection failed (HTTP {{status}}).',
    loopNotClosed: 'This does not close a loop — the chain does not come back to this node, so the connection was not saved. Draw it again and choose "Connection" if you meant an ordinary connection.',
    loopSave: 'Saving the loop failed (HTTP {{status}}).',
    linkRetype: 'Changing the connection type failed (HTTP {{status}}).',
    loopDirection: 'Saving the loop direction failed (HTTP {{status}}).',
    suggestHttp: 'Fetching suggestions failed (HTTP {{status}}).',
    suggest: 'Fetching suggestions failed.',
    suggestWithMessage: 'Fetching suggestions failed: {{message}}',
    aiUnavailable: 'AI is not available (the API key is missing).',
    edgeTypes: 'Typing the connections failed (HTTP {{status}}).',
  },
  drawer: {
    onMap: 'On the map',
    consequences: 'Consequences',
    blockers: 'Blockers',
    crossLinks: 'Cross-links',
    loops: 'Loops',
    loopsHint: 'Draws the loops and the handle for dragging a connection from one node to another',
    factCheck: 'AI fact check',
    factCheckHint: 'Checks new nodes against the knowledge base',
    edgeTypesHint: "A connection type can be chosen when adding a consequence; the others show the default 'leads to'.",
    edgeTypesCount: 'Connection types: {{typed}}/{{total}} chosen by people',
    edgeTypesAi: ', {{count}} by AI',
    typeEdges: 'Type the connections',
    typeEdgesHint: 'AI reads each untyped connection in its chain and proposes a type. A person’s choice is kept.',
    typing: 'Typing…',
    findLoops: 'Suggest loops',
    findCross: 'Suggest cross-links',
    searching: 'Searching…',
    pendingLoops: 'loops to review',
    pendingCross: 'connections to review',
    queueHint: 'Suggestions go into a queue; they reach the map only when someone accepts them.',
    pulseAt: 'Pulse {{time}}',
    pulseCandidates: '💓 Pivot point candidates {{count}}',
    pulseNew: ', {{count}} new',
    pivots: 'Pivot points',
    askTitle: 'Ask the map',
    askChoices: 'Where are the choices?',
    askLoops: 'Where does the system tend?',
    askBlockers: 'What is in the way?',
    askHint: 'One reading at a time. The map dims everything that does not answer the question.',
    analysis: 'Analysis',
  },
  readings: {
    loadFailed: 'Loading the readings failed: {{message}}',
    retry: 'Try again',
    reading: 'Reading the map…',
    none: 'No readings.',
    totals: {
      consequences: 'consequences',
      up: 'thumbs up',
      voted: 'nodes voted on',
      upPerNode: 'up / node',
      leaves: 'leaves',
      grounded: 'with sources',
    },
    heat: {
      title: 'Branch heat',
      hint: 'Thumbs per node under each variable. The map’s average is {{mean}}. A small hot branch is where the room keeps coming back.',
      rowTitle: '{{nodes}} nodes · {{writers}} writers · {{grounded}} with sources · depth {{depth}}',
      rowSub: '{{scenario}} · {{nodes}} nodes · {{writers}} writers',
      perNode: '/ node',
    },
    chains: {
      title: 'Hottest chains',
      hint: 'Thumbs summed from root to leaf. The story the room believes in most; it cuts across groups and branches.',
      steps: '{{scenario}} · {{depth}} steps',
      none: 'No chains yet.',
    },
    polarity: {
      title: 'Arrow polarity',
      hint: '{{share}} % of the arrows weaken or block. Without them the map cannot have balancing loops.',
    },
    authorship: {
      title: 'Who wrote where',
      hint: 'On average {{mean}} writers per branch, {{writers}} writers on the map.',
      monologues: 'Branches with a single writer (a monologue, not a conversation):',
      nodes: '{{count}} nodes',
      none: 'Every larger branch has more than one writer.',
    },
    surprises: {
      title: 'Surprises deep down',
      hint: 'Many thumbs on a deep node, few on its parent: a find on a quiet path.',
      sub: 'depth {{depth}} · under: {{parent}} (+{{up}})',
      none: 'No surprises yet.',
    },
    contested: {
      title: 'Contested',
      hint: 'Many thumbs both up and down: the room disagrees on whether this matters. A place for the wall discussion.',
      none: 'No contested nodes.',
    },
    hotLeaves: {
      title: 'Hot leaves',
      hint: 'A leaf with many thumbs: this is where the room stopped thinking. The next round’s “what follows from this”.',
      sub: '{{scenario}} · depth {{depth}}',
    },
    multiParent: {
      title: 'Two parents',
      hint: 'A node that follows from two places: the room’s strongest convergence.',
      parents: '{{count}} parents',
      none: 'None yet.',
    },
    written: 'The map was written {{from}} – {{to}}, {{nodes}} nodes.',
    rereading: 'Reading…',
    reread: 'Read again',
  },
  analysis: {
    title: 'Analyse the map',
    labelPlaceholder: 'A name for this run (optional)',
    running: 'Analysing…',
    run: 'Analyse',
    runningHint: 'Reads the whole map — about a minute.',
    untitled: 'Untitled run',
    promptVersion: 'prompt v{{version}}',
    tendency: 'Where the system tends',
    keyChoices: 'Decisive choices',
    loops: 'Loops',
    blockers: 'Blockers',
    attention: 'Attention next',
    earlier: 'Earlier runs',
    listMeta: '{{nodes}} nodes, {{choices}} choices',
    refLoop: 'loop: {{title}}',
    refBlocker: 'blocker: {{text}}',
    countConsequences: '{{count}} consequences',
    countVariables: '{{count}} variables',
    countItems: '{{count}} items',
    loadFailed: 'Loading the analyses failed: {{message}}',
    failed: 'The analysis failed: {{message}}',
  },
  link: {
    connection: 'Connection',
    connectionSub: 'This also leads to that — the node has more than one cause.',
    loop: 'Loop',
    loopSub: 'The chain comes back on itself — a reinforcing or balancing loop.',
    same: 'Is the same',
    sameSub: 'The same thing said twice in different branches — not an effect but an overlap.',
  },
  loop: {
    tone: { up: 'Virtuous circle', down: 'Vicious circle', unknown: 'Loop — direction not judged' },
    word: { up: 'virtuous circle', down: 'vicious circle', none: 'loop' },
    hint: { up: 'The loop improves the situation on every round.', down: 'The loop makes the situation worse on every round.' },
    pick: {
      up: { label: 'Virtuous circle', sub: 'Gets better on every round.' },
      down: { label: 'Vicious circle', sub: 'Gets worse on every round.' },
      unknown: { label: 'I don’t know yet', sub: 'Leave it unjudged — you can decide later.' },
    },
  },
  suggestions: {
    loopsTitle: 'Suggested loops',
    crossTitle: 'Suggested cross-links',
    noLoops: 'AI found no chains that come back on themselves. That does not mean there are none — draw a loop by hand if you see one.',
    noCross: 'AI found no connections between branches that the map does not already have.',
    retype: 'Change the relation type',
    accept: 'Add to the map',
    dismiss: 'Dismiss',
  },
  effectPicker: {
    question: 'How does this follow from the previous one?',
    relation: 'Relation:',
    change: 'change',
    more: 'more',
  },
  scenarioPicker: {
    change: 'Change scenario',
    pick: 'Choose a scenario',
    listLabel: 'Scenario',
  },
  node: {
    scenario: 'Scenario',
    variable: 'Variable',
    consequence: 'Consequence',
    seamRoot: 'Merged root: {{count}} scenarios. Tap: show the family.',
    seamPath: 'The path continues at a seam: the same thing in {{count}} scenarios. Tap: show the family.',
    aiSuggests: 'AI suggests a connection from this node — not reviewed',
  },
};

export const impactMapV2Sv = {
  effectTypes: {
    leads_to: 'leder till',
    enables: 'möjliggör',
    blocks: 'hindrar',
    reinforces: 'förstärker',
    weakens: 'försvagar',
    nullifies: 'upphäver',
    requires: 'förutsätter',
    delays: 'fördröjer',
    relates_to: 'hänger ihop med',
    is_same: 'samma sak',
  },
  view: {
    tabMap: 'Karta',
    tabReadings: 'Avläsningar',
    noInstanceTitle: 'Ingen instans',
    noInstanceBody: 'Öppna kartan med en instans:',
    pickScenarioTitle: 'Välj ett scenario',
    pickScenarioIndividual: 'Vyn Egna visar dina stigar i ett scenario.',
    pickScenarioScenario: 'Scenariovyn visar alla stigar i ett scenario.',
    pickScenarioHint: 'Välj ett scenario eller se hela kartan i vyn Alla.',
    allView: 'Alla →',
    loading: 'Laddar kartan…',
    emptyTitle: 'Kartan är tom',
    emptyBody: 'Det finns inga noder i den här vyn ännu. Lägg till den första konsekvensen i konsekvensstigen eller byt vy.',
    backToMap: '← Tillbaka till kartan',
    blockerBadge: 'Hinder',
    loopTitleBalancing: 'Balanserande slinga',
    loopTitleReinforcing: 'Förstärkande slinga',
  },
  errors: {
    blockerAdd: 'Det gick inte att lägga till hindret (HTTP {{status}}).',
    commentSave: 'Det gick inte att spara anteckningen.',
    voteOwn: 'Du kan inte rösta på din egen konsekvens.',
    vote: 'Röstningen misslyckades.',
    linkExists: 'De här är redan sammankopplade.',
    linkCreate: 'Det gick inte att skapa kopplingen (HTTP {{status}}).',
    loopNotClosed: 'Det här sluter ingen slinga — kedjan kommer inte tillbaka till den här noden, så kopplingen sparades inte. Rita den på nytt och välj "Koppling" om du menade en vanlig koppling.',
    loopSave: 'Det gick inte att spara slingan (HTTP {{status}}).',
    linkRetype: 'Det gick inte att byta kopplingstyp (HTTP {{status}}).',
    loopDirection: 'Det gick inte att spara slingans riktning (HTTP {{status}}).',
    suggestHttp: 'Det gick inte att hämta förslag (HTTP {{status}}).',
    suggest: 'Det gick inte att hämta förslag.',
    suggestWithMessage: 'Det gick inte att hämta förslag: {{message}}',
    aiUnavailable: 'AI är inte tillgänglig (API-nyckeln saknas).',
    edgeTypes: 'Det gick inte att typa kopplingarna (HTTP {{status}}).',
  },
  drawer: {
    onMap: 'På kartan',
    consequences: 'Konsekvenser',
    blockers: 'Hinder',
    crossLinks: 'Korslänkar',
    loops: 'Slingor',
    loopsHint: 'Ritar slingorna och handtaget som du drar en koppling med från en nod till en annan',
    factCheck: 'AI-faktagranskning',
    factCheckHint: 'Granskar nya noder mot kunskapsbasen',
    edgeTypesHint: "Kopplingstypen kan väljas när en konsekvens läggs till; de övriga visar standardtypen 'leder till'.",
    edgeTypesCount: 'Kopplingstyper: {{typed}}/{{total}} valda av människor',
    edgeTypesAi: ', {{count}} av AI',
    typeEdges: 'Typa kopplingarna',
    typeEdgesHint: 'AI läser varje otypad koppling i sin kedja och föreslår en typ. En människas val behålls.',
    typing: 'Typar…',
    findLoops: 'Föreslå slingor',
    findCross: 'Föreslå korslänkar',
    searching: 'Söker…',
    pendingLoops: 'slingor att granska',
    pendingCross: 'kopplingar att granska',
    queueHint: 'Förslagen hamnar i en kö; de kommer till kartan först när någon godkänner dem.',
    pulseAt: 'Puls {{time}}',
    pulseCandidates: '💓 Kandidater till vändpunkter {{count}}',
    pulseNew: ', {{count}} nya',
    pivots: 'Vändpunkter',
    askTitle: 'Fråga kartan',
    askChoices: 'Var finns valen?',
    askLoops: 'Vart lutar systemet?',
    askBlockers: 'Vad står i vägen?',
    askHint: 'En läsning i taget. Kartan tonar ned allt som inte svarar på frågan.',
    analysis: 'Analys',
  },
  readings: {
    loadFailed: 'Det gick inte att hämta avläsningarna: {{message}}',
    retry: 'Försök igen',
    reading: 'Läser kartan…',
    none: 'Inga avläsningar.',
    totals: {
      consequences: 'konsekvenser',
      up: 'tummar upp',
      voted: 'noder röstade på',
      upPerNode: 'upp / nod',
      leaves: 'löv',
      grounded: 'med källor',
    },
    heat: {
      title: 'Grenarnas värme',
      hint: 'Tummar per nod under varje variabel. Kartans medelvärde är {{mean}}. En liten het gren är den som rummet återvänder till.',
      rowTitle: '{{nodes}} noder · {{writers}} skribenter · {{grounded}} med källor · djup {{depth}}',
      rowSub: '{{scenario}} · {{nodes}} noder · {{writers}} skrib.',
      perNode: '/ nod',
    },
    chains: {
      title: 'De hetaste kedjorna',
      hint: 'Tummar summerade från roten till lövet. Berättelsen som rummet tror mest på; den skär genom grupper och grenar.',
      steps: '{{scenario}} · {{depth}} steg',
      none: 'Inga kedjor ännu.',
    },
    polarity: {
      title: 'Pilarnas polaritet',
      hint: '{{share}} % av pilarna försvagar eller hindrar. Utan dem kan kartan inte ha balanserande slingor.',
    },
    authorship: {
      title: 'Vem skrev var',
      hint: 'I genomsnitt {{mean}} skribenter per gren, {{writers}} skribenter på kartan.',
      monologues: 'Grenar med en enda skribent (en monolog, inte ett samtal):',
      nodes: '{{count}} noder',
      none: 'Varje större gren har fler än en skribent.',
    },
    surprises: {
      title: 'Överraskningar på djupet',
      hint: 'Många tummar på en djup nod, få på dess förälder: ett fynd på en tyst stig.',
      sub: 'djup {{depth}} · under: {{parent}} (+{{up}})',
      none: 'Inga överraskningar ännu.',
    },
    contested: {
      title: 'Omstridda',
      hint: 'Många tummar både upp och ned: rummet är oense om huruvida det här spelar roll. En plats för samtalet vid väggen.',
      none: 'Inga omstridda noder.',
    },
    hotLeaves: {
      title: 'Heta löv',
      hint: 'Ett löv med många tummar: här slutade rummet tänka. Nästa rundas ”vad följer av det här”.',
      sub: '{{scenario}} · djup {{depth}}',
    },
    multiParent: {
      title: 'Två föräldrar',
      hint: 'En nod som följer av två ställen: rummets starkaste samstämmighet.',
      parents: '{{count}} föräldrar',
      none: 'Inga ännu.',
    },
    written: 'Kartan skrevs {{from}} – {{to}}, {{nodes}} noder.',
    rereading: 'Läser…',
    reread: 'Läs på nytt',
  },
  analysis: {
    title: 'Analysera kartan',
    labelPlaceholder: 'Ett namn för den här körningen (valfritt)',
    running: 'Analyserar…',
    run: 'Analysera',
    runningHint: 'Läser hela kartan — ungefär en minut.',
    untitled: 'Namnlös körning',
    promptVersion: 'prompt v{{version}}',
    tendency: 'Vart systemet lutar',
    keyChoices: 'Avgörande val',
    loops: 'Slingor',
    blockers: 'Hinder',
    attention: 'Uppmärksamhet härnäst',
    earlier: 'Tidigare körningar',
    listMeta: '{{nodes}} noder, {{choices}} val',
    refLoop: 'slinga: {{title}}',
    refBlocker: 'hinder: {{text}}',
    countConsequences: '{{count}} konsekvenser',
    countVariables: '{{count}} variabler',
    countItems: '{{count}} punkter',
    loadFailed: 'Det gick inte att hämta analyserna: {{message}}',
    failed: 'Analysen misslyckades: {{message}}',
  },
  link: {
    connection: 'Koppling',
    connectionSub: 'Också det här leder dit — noden har flera orsaker.',
    loop: 'Slinga',
    loopSub: 'Kedjan kommer tillbaka till sig själv — en förstärkande eller balanserande slinga.',
    same: 'Är samma',
    sameSub: 'Samma sak sagd två gånger i olika grenar — ingen effekt utan en överlappning.',
  },
  loop: {
    tone: { up: 'God cirkel', down: 'Ond cirkel', unknown: 'Slinga — riktningen inte bedömd' },
    word: { up: 'god cirkel', down: 'ond cirkel', none: 'slinga' },
    hint: { up: 'Slingan förbättrar läget för varje varv.', down: 'Slingan förvärrar läget för varje varv.' },
    pick: {
      up: { label: 'God cirkel', sub: 'Blir bättre för varje varv.' },
      down: { label: 'Ond cirkel', sub: 'Blir sämre för varje varv.' },
      unknown: { label: 'Jag vet inte ännu', sub: 'Lämna obedömd — du kan bestämma senare.' },
    },
  },
  suggestions: {
    loopsTitle: 'Föreslagna slingor',
    crossTitle: 'Föreslagna korslänkar',
    noLoops: 'AI hittade inga kedjor som kommer tillbaka till sig själva. Det betyder inte att det inte finns några — rita en slinga för hand om du ser en.',
    noCross: 'AI hittade inga kopplingar mellan grenar som kartan inte redan har.',
    retype: 'Byt relationstyp',
    accept: 'Lägg till på kartan',
    dismiss: 'Avvisa',
  },
  effectPicker: {
    question: 'Hur följer det här av det föregående?',
    relation: 'Relation:',
    change: 'ändra',
    more: 'fler',
  },
  scenarioPicker: {
    change: 'Byt scenario',
    pick: 'Välj ett scenario',
    listLabel: 'Scenario',
  },
  node: {
    scenario: 'Scenario',
    variable: 'Variabel',
    consequence: 'Konsekvens',
    seamRoot: 'Sammanslagen rot: {{count}} scenarier. Tryck: visa familjen.',
    seamPath: 'Stigen fortsätter i en söm: samma sak i {{count}} scenarier. Tryck: visa familjen.',
    aiSuggests: 'AI föreslår en koppling från den här noden — inte granskad',
  },
};
